

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://9a65e97ebe8141fca0c4fd686f70996b@sentry.wixpress.com/5894", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/92f03a7474915e95/packages/payments-my-wallet/src/components/MyWallet/Widget/index.tsx';
    import createController from '/home/builduser/work/92f03a7474915e95/packages/payments-my-wallet/src/components/MyWallet/controller/index.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    import { createErrorHandler } from '@wix/yoshi-flow-editor/runtime/esm/error-handler/createErrorHandler';
    

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa/cssVars';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  var importedApp = {};

    var componentName = 'MyWallet';
    var projectName = 'payments-my-wallet';
    var sentryConfig = {
      DSN: 'https://9a65e97ebe8141fca0c4fd686f70996b@sentry.wixpress.com/5894',
      id: 'undefined',
      projectName: 'payments-my-wallet',
      teamName: 'payments',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/92f03a7474915e95/packages/payments-my-wallet/src/components/MyWallet/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"scopes":["payments-checkout"],"centralized":true};
    var fedopsConfig = null;
    var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/92f03a7474915e95/packages/payments-my-wallet/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"app.payment-method.paypal.default-title":"PayPal","designTab.withItems.itemListPicker":"Dividers opacity & color","app.payment-method.expiration-date.label":"Expiration date: <span>{date} {expirationStatus}</span>","designTab.withoutItems.backgroundPicker":"Background opacity & color","app.payment-method.card.title":"{title} ({lastFourDigits})","app.title":"Wallet","app.payment-method.paypal.title":"{title} ({email})","designTab.withItems.itemDividersHeaderPicker":"1st divider opacity & color","app.error-page.technical-issue.cta.text":"Reload Page","app.error-page.fetch-failed.title":"Unable to load your saved payment methods","app.payment-method.account-holder.label":"Account holder: {accountHolder}","textTab.noItemsMessage.label":"No saved payment methods title","designTab.bgBordersSection.manageMenu.title":"Manage menu","app.payment-method.manage-menu.remove-item.text":"Remove Payment Method","app.remove-payment-method-modal.submit-button.text":"Remove Payment Method","designTab.withoutItems.noItemsInfoFontColorLabel":"No saved payment methods subtitle","designTab.withoutItems.subtitleFontColorLabel":"Page subtitle","app.error-page.fetch-failed.description":"This is because of a technical issue on our end. Try reloading the page.","app.settings.design.back-button.label":"Back","designTab.withoutItems.label":"Nothing saved","app.payment-method.manage-button.text":"Manage","app.empty-state-page.title":"You haven’t saved any payment methods yet","designTab.badge.textColorPicker.label":"Text color","app.error-page.technical-issue.description":"Looks like we weren’t able to load your saved payment methods due to a technical issue. Try reloading the page.","designTab.withItems.itemDividersSectionHeader":"Dividers","designTab.withoutItems.borderColorPicker":"Border opacity & color","app.modal.close-button.aria-label":"Close","app.remove-payment-method-modal.title":"Remove payment method?","designTab.withoutItems.textSectionHeader":"Text Fonts & Colors","app.add-payment-method-modal.cancel-button.text":"Cancel","designTab.buttonsSection.title":"Buttons","textTab.noItemsInfo.label":"No saved payment methods subtitle","app.add-payment-method-modal.title":"Add payment method","app.payment-method.cardholder.label":"Cardholder: {cardholderName}","designTab.withoutItems.noItemsMessageFontColorLabel":"No saved payment methods title","app.toast.remove-payment-method.error.text":"We couldn't remove your payment method due to a technical issue on our side. Try again.","app.add-payment-method-modal.submit-button.text":"Add Payment Method","designTab.fontColorPicker.label":"Text font and color","app.remove-payment-method-modal.cancel-button.text":"Cancel","menuTabsButtons.design":"Design","designTab.textSection.text.primary.title":"Primary text","app.payment-method.status.expired":"(Expired)","app.toast.payment-method-removed.text":"Payment method removed.","app.toast.make-primary.error.text":"We couldn't save the changes to your default payment method. Try again.","designTab.withoutItems.borderWidthSlider":"Border width","menuTabsButtons.text":"Text","designTab.textSection.text.secondary.title":"Secondary text","menuTabsButtons.main":"Main","app.remove-payment-method-modal.text":"Once removed, {paymentMethodTitle} will no longer be saved for faster checkout. <br /> You can save it again at any time.","app.card.make-primary":"Set as Default","app.add-payment-method-button.text":"Add Payment Method","app.subtitle":"Save your payment details for faster checkout.","designTab.withoutItems.resetStyles":"Reset to original design","app.payment-method.primary-mark.label":"Default","designTab.buttonsSection.button.primary.secondary":"Secondary button","designTab.withItems.itemListWidthSlider":"Dividers width","designTab.badgesSection.title":"Badges","designTab.buttonsSection.button.primary.title":"Primary button","designTab.withoutItems.borderRadius.label":"Corner radius","app.payment-method.manage-button.aria-label":"Manage {paymentMethodTitle}","designTab.withoutItems.backgroundsSectionHeader":"Background & Border","app.toast.payment-method-added.text":"Payment method added.","app.empty-state-page.subtitle":"Securely save your payment details for faster checkout whenever you place an order.","designTab.buttonsSection.borderRadius.label":"Corner radius","textTab.title.label":"Page title","app.error-page.fetch-failed.cta.text":"Reload Page","app.payment-method.card.default-title":"Credit card","textTab.subtitle.label":"Page subtitle","designTab.withItems.itemDividersHeaderWidthSlider":"1st divider width","designTab.buttonsSection.borderWidth.label":"Border width","mainTab.message":"For faster checkout, members can manage their payment details after their first order.","designTab.buttonsSection.textStyle.label":"Text","designTab.fontPickerPanel.title":"Choose your font","textTab.pageSettings.title":"General","mainTab.buttonLabel":"Customize","app.error-page.technical-issue.title":"There was a technical issue on our end","designTab.withoutItems.titleFontColorLabel":"Page title"};
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "4aebd0cb-fbdb-4da7-b5d1-d05660a30172";
    var componentId = "6467c15e-af3c-4e8d-b167-41bfb8efc32a";
    var localeDistPath = 'assets/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = true;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/92f03a7474915e95/packages/payments-my-wallet/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createErrorHandler,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
      Sentry: window.Sentry && {
        forceLoad: () => window.Sentry.forceLoad(),
        onLoad: (fn) => window.Sentry.onLoad(() => fn(window.Sentry))
      }
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
